


















































import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getRules, checkIsFirst } from '../api';
import qs from 'qs';
import { Toast } from 'vant';

@Component
export default class Home extends Vue {
  showread: boolean = false;
  ruleStr: string = '';
  errinfo: string = '';
  nowx: boolean = false;
  qrinfo: any = {};
  async mounted() {
    const ret = await getRules();
    this.ruleStr = ret.data;
  }
  goactive() {
    const unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      this.errinfo = '请在微信中打开，参与活动';
      this.nowx = true;
      return false;
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    this.checkExist(unionId);
  }
  checkExist(unionId: any) {
    const qrinfo = window.localStorage.getItem('qrinfo');
    if (!qrinfo) {
      checkIsFirst(unionId).then((res: any) => {
        if (res.code === 200) {
          this.qrinfo.DDH = res.data.qr_ddh;
          this.qrinfo.HXM = res.data.qr_hxm;
          this.qrinfo.JZSJ = res.data.qr_jzsj;
          this.qrinfo.KSSJ = res.data.qr_kssj;
          this.qrinfo.TB = res.data.qr_tb;
          this.qrinfo.ZYSX = res.data.qr_zysx;
          this.qrinfo.unionid = res.data.userId;
          this.qrinfo.dreamsch = res.data.dreamsch;
          this.qrinfo.phone = res.data.phone;
          this.qrinfo.qqnum = res.data.qqnum;
          // if (res.data.realcity || res.data.realname) {
          //   this.qrinfo.realcity = res.data.realcity;
          //   this.qrinfo.realname = res.data.realname;
          // }
          this.qrinfo.realcity = res.data.realcity;
          this.qrinfo.realname = res.data.realname;
          this.qrinfo.name = res.data.name;
          this.qrinfo.qqnum = res.data.qqnum;
          this.qrinfo.phone = res.data.phone;
          if (!res.data.realcity || !res.data.realname) {
            window.localStorage.removeItem('qrinfo');
            this.$router.push('active');
          } else {
            this.qrinfo.realcity = res.data.realcity;
            this.qrinfo.realname = res.data.realname;
            window.localStorage.setItem('qrinfo', qs.stringify(this.qrinfo));
            this.$router.push('isactived');
          }
        } else {
          this.$router.push('active?isnew=' + true);
        }
      });
    } else {
      const qrdata = qs.parse(qrinfo);
      if (unionId !== qrdata.unionid) {
        window.localStorage.removeItem('qrinfo');
        window.location.reload();
      }
      if (!qrdata.realcity || !qrdata.realname) {
        window.localStorage.removeItem('qrinfo');
        this.$router.push('active');
      } else {
        this.$router.push('isactived');
      }
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
